import { render } from "./help_support.html?vue&type=template&id=381edcd5&external"
import script from "./help_support.js?vue&type=script&lang=js&external"
export * from "./help_support.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__